import React, {
  createContext,
  useContext,
  useState,
  PropsWithChildren,
} from "react";
import { IThreat } from "../../pages/RiskAssesment/ThreatSource/modal";
import { supplyChainRiskAssesment } from "../../pages/RiskAssesment/modal";

// Define the interface for context values
interface RiskAssessmentContextType {
  selectedRiskAssessment: any;
  setSelectedRiskAssessment: React.Dispatch<React.SetStateAction<any>>;
  tabValue: number;
  setTabValue: React.Dispatch<React.SetStateAction<number>>;
  likehoodList: any[];
  setLikehoodList: React.Dispatch<React.SetStateAction<any>>;
  adverseImpactList: any[];
  setAdverseImpactList: React.Dispatch<React.SetStateAction<any>>;
  riskResponseList: any[];
  setRiskResponseList: React.Dispatch<React.SetStateAction<any>>;
  residualRiskList: any[];
  setResidualRiskList: React.Dispatch<React.SetStateAction<any>>;
  inherentRisksList: any[];
  setInherentRisksList: React.Dispatch<React.SetStateAction<any>>;
  controlsList: any[];
  setControlsList: React.Dispatch<React.SetStateAction<any>>;
  controlTypeList: any[];
  setControlTypeList: React.Dispatch<React.SetStateAction<any>>;
  threatSourceList: any[];
  setThreatSourceList: React.Dispatch<React.SetStateAction<any>>;
  vulnerabilityList: any[];
  setVulnerabilityList: React.Dispatch<React.SetStateAction<any>>;
  threatEventList: any[];
  setThreatEventList: React.Dispatch<React.SetStateAction<any>>;

  cyberRiskAssessmentList: any[];
  setCyberRiskAssessmentList: React.Dispatch<React.SetStateAction<any>>;
  sC_RiskAssesmentList: supplyChainRiskAssesment[];
  setSc_RiskAssesmentList: React.Dispatch<
    React.SetStateAction<supplyChainRiskAssesment[]>
  >;

  selectedSupplyChainRiskAssessment: any;
  setSelectedSupplyChainRiskAssessment: React.Dispatch<
    React.SetStateAction<any>
  >;

  selectedCyberSecurityRiskAssessment: any;
  setSelectedCyberSecurityRiskAssessment: React.Dispatch<
    React.SetStateAction<any>
  >;
}

// Create context with initial values
const RiskAssessmentContext = createContext<
  RiskAssessmentContextType | undefined
>(undefined);

// Create a provider component to wrap your app
export const RiskAssessmentProvider = ({ children }: PropsWithChildren<{}>) => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [likehoodList, setLikehoodList] = useState<any>([]);
  const [adverseImpactList, setAdverseImpactList] = useState<any>([]);
  const [riskResponseList, setRiskResponseList] = useState<any>([]);
  const [residualRiskList, setResidualRiskList] = useState<any>([]);
  const [inherentRisksList, setInherentRisksList] = useState<any>([]);
  const [controlsList, setControlsList] = useState<any>([]);
  const [controlTypeList, setControlTypeList] = useState<any>([]);
  const [threatSourceList, setThreatSourceList] = useState<IThreat[]>([]);
  const [vulnerabilityList, setVulnerabilityList] = useState<any>([]);
  const [threatEventList, setThreatEventList] = useState<IThreat[]>([]);

  const [cyberRiskAssessmentList, setCyberRiskAssessmentList] = useState<any>(
    []
  );
  const [sC_RiskAssesmentList, setSc_RiskAssesmentList] = useState<
    supplyChainRiskAssesment[]
  >([]);

  const [selectedRiskAssessment, setSelectedRiskAssessment] = useState<any>({});
  const [
    selectedSupplyChainRiskAssessment,
    setSelectedSupplyChainRiskAssessment,
  ] = useState<any>({});
  const [
    selectedCyberSecurityRiskAssessment,
    setSelectedCyberSecurityRiskAssessment,
  ] = useState<any>({});

  return (
    <RiskAssessmentContext.Provider
      value={{
        selectedRiskAssessment,
        setSelectedRiskAssessment,
        tabValue,
        setTabValue,
        likehoodList,
        setLikehoodList,
        adverseImpactList,
        setAdverseImpactList,
        riskResponseList,
        setRiskResponseList,
        residualRiskList,
        setResidualRiskList,
        inherentRisksList,
        setInherentRisksList,
        controlsList,
        setControlsList,
        controlTypeList,
        setControlTypeList,
        threatSourceList,
        setThreatSourceList,
        vulnerabilityList,
        setVulnerabilityList,
        threatEventList,
        setThreatEventList,

        cyberRiskAssessmentList,
        setCyberRiskAssessmentList,

        selectedSupplyChainRiskAssessment,
        setSelectedSupplyChainRiskAssessment,

        selectedCyberSecurityRiskAssessment,
        setSelectedCyberSecurityRiskAssessment,

        sC_RiskAssesmentList,
        setSc_RiskAssesmentList,
      }}
    >
      {children}
    </RiskAssessmentContext.Provider>
  );
};

// Create a custom hook for using RiskAssessmentContext
export const useRiskAssessmentContext = () => {
  const context = useContext(RiskAssessmentContext);
  if (!context) {
    throw new Error(
      "useRiskAssessmentContext must be used within a RiskAssessmentContext"
    );
  }
  return context;
};

export default RiskAssessmentContext;
